import { render } from "./AddDevolutiva.vue?vue&type=template&id=004d5ee4&scoped=true"
import script from "./AddDevolutiva.vue?vue&type=script&lang=js"
export * from "./AddDevolutiva.vue?vue&type=script&lang=js"

import "./AddDevolutiva.vue?vue&type=style&index=0&id=004d5ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004d5ee4"]])

export default __exports__